import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import CSSModules from 'helpers/CSSModulesUtil'

import Avatar from 'react-toolbox/lib/avatar'
import { ListItem } from 'react-toolbox/lib/list'
import { mapProps, branch, renderComponent } from 'recompose'
import { Flex, Box } from 'reflexbox'
import DatePicker from 'react-toolbox/lib/date_picker'
import Body from 'components/typography/body2/index'
import DeleteButton from './DeleteButton'
import { convertUTCDateToLocalDate, getMonthDateYearString } from 'helpers/DateUtil'

import styles from './styles.scss'

const withStyle = CSSModules(styles)

const RowItem = (
  {
    readonly,
    name,
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange
  }) => {
  return (
    <Flex align='center' auto>
      <div styleName='substituteName'>
        <Body>{ name }</Body>
      </div>
      <div styleName='startDate'>
        <DatePicker
          inputFormat={(value) => getMonthDateYearString(value)}
          onChange={onStartDateChange}
          value={convertUTCDateToLocalDate(new Date(`${startDate}`))}
          readonly={readonly}
          label='Start Date'
        />
      </div>
      <div styleName='endDate'>
        <DatePicker
          inputFormat={(value) => getMonthDateYearString(value)}
          onChange={onEndDateChange}
          value={new Date(`${endDate}`)}
          readonly={readonly}
          label='End Date'
        />
      </div>
      <Box auto/>
    </Flex>
  )
}

const StyledRow = withStyle(RowItem)

const DateItemReadOnly = ({ image, ...rest }) => (
  <ListItem
    avatar={image}
    itemContent={<StyledRow {...rest} readonly/>}
    ripple={false}
  />
)

const DateItemEdit = ({ onRemove, image, ...rest }) => (
  <ListItem
    avatar={image}
    itemContent={<StyledRow {...rest}/>}
    rightActions={[<DeleteButton onClick={onRemove} key='deleteButton'/>]}
    ripple={false}
    selectable
  />
)

export default R.compose(
  mapProps(({ onRemove, onDelete, onChange, substitute, edit }) => ({
    onStartDateChange: (date) => onChange({ [substitute.username]: { ...substitute, startDate: date.toUTCString() } }),
    onEndDateChange: (date) => onChange({ [substitute.username]: { ...substitute, endDate: date.toUTCString() } }),
    onRemove: () => onRemove(substitute),
    edit,
    ...substitute,
  })),
  branch(
    R.propEq('edit', true),
    renderComponent(DateItemEdit)
  )
)(DateItemReadOnly)
